// Material color palette and per-material particle behaviour
// Each material maps to: primary color, glow, particle color, particle style

export const MATERIALS = {
  crystal:    { name: 'Crystal',      primary: '#b8d4f0', glow: '#7aaee8', particles: '#e8f4ff', style: 'faceted',  durationRange: [3500, 5500] },
  ember:      { name: 'Ember',        primary: '#e8640a', glow: '#ff9040', particles: '#ffcc60', style: 'flare',    durationRange: [1500, 2500] },
  obsidian:   { name: 'Obsidian',     primary: '#2a2040', glow: '#4040a0', particles: '#8080ff', style: 'drift',    durationRange: [4000, 6000] },
  storm:      { name: 'Storm',        primary: '#6080c0', glow: '#a0c0ff', particles: '#e0eeff', style: 'electric', durationRange: [1500, 3000] },
  silk:       { name: 'Silk',         primary: '#e8c0d0', glow: '#d890a8', particles: '#fff0f4', style: 'soft',     durationRange: [4000, 6000] },
  iron:       { name: 'Iron',         primary: '#808090', glow: '#b0b8c8', particles: '#e0e8f0', style: 'sharp',    durationRange: [1000, 2000] },
  verdant:    { name: 'Verdant',      primary: '#2a7a3a', glow: '#50c060', particles: '#90ff90', style: 'pulse',    durationRange: [2500, 4000] },
  void:       { name: 'Void',         primary: '#0a0010', glow: '#5020a0', particles: '#8040ff', style: 'rare',     durationRange: [4000, 7000] },
  molten:     { name: 'Molten Metal', primary: '#c84000', glow: '#ff6020', particles: '#ffaa40', style: 'flare',    durationRange: [1500, 3000] },
  stillwater: { name: 'Still Water',  primary: '#2050a0', glow: '#4080d0', particles: '#c0e0ff', style: 'drift',    durationRange: [4000, 6000] },
  smoke:      { name: 'Smoke',        primary: '#505060', glow: '#8090a0', particles: '#c0c8d8', style: 'drift',    durationRange: [3000, 5000] },
  stone:      { name: 'Stone',        primary: '#5a5850', glow: '#8a8878', particles: '#c0b898', style: 'sharp',    durationRange: [2000, 4000] },
  livingwood: { name: 'Living Wood',  primary: '#3a6020', glow: '#609040', particles: '#a0d070', style: 'pulse',    durationRange: [3000, 5000] },
  wovenlight: { name: 'Woven Light',  primary: '#d0c040', glow: '#f0e060', particles: '#fff8c0', style: 'soft',     durationRange: [3000, 5000] },
  coral:      { name: 'Coral',        primary: '#c04850', glow: '#e07080', particles: '#ffc0c8', style: 'pulse',    durationRange: [2500, 4000] },
  frost:      { name: 'Frost',        primary: '#a0c8e0', glow: '#c8e8ff', particles: '#f0f8ff', style: 'faceted',  durationRange: [3000, 5000] },
  clay:       { name: 'Clay',         primary: '#8a5040', glow: '#c07860', particles: '#e0b090', style: 'drift',    durationRange: [3000, 5000] },
};

export const DEFAULT_MATERIAL = {
  name: '',
  primary: '#7040d0',
  glow: '#9060e0',
  particles: '#c8a0ff',
  style: 'default',
  durationRange: [2500, 4500],
};

export function getMaterial(name) {
  if (!name) return DEFAULT_MATERIAL;
  // Normalise: lowercase, strip spaces and common words
  const key = name.toLowerCase()
    .replace(/\s+/g, '')
    .replace('cloud', '')
    .replace('metal', '')
    .replace('wood', 'wood')
    .replace(/[^a-z]/g, '');

  if (MATERIALS[key]) return MATERIALS[key];

  // Alias table for builder-prompt material names
  const aliases = {
    stormcloud:   'storm',
    moltenmental: 'molten',
    moltenmetal:  'molten',
    stillwater:   'stillwater',
    livingwood:   'livingwood',
    wovenlight:   'wovenlight',
  };
  const resolved = aliases[key];
  if (resolved) return MATERIALS[resolved];

  // Fuzzy: first key that the input contains or that contains the input
  for (const [k, v] of Object.entries(MATERIALS)) {
    if (key.includes(k) || k.includes(key)) return v;
  }

  return DEFAULT_MATERIAL;
}
